<template>
  <div class='list-filter'>
    <div class="filter-type">
      <input type="text" placeholder="Filter by keyword" v-model="filter" @input.lazy="applyFilter()">
    </div>

    <div class="filter-type" v-if="filterLevels">
      <div class='inline-filter tag-block'>
        <label>Level:</label>
      </div>
      <div v-for="level in levelFilters" class='inline-filter tag-block'>
        <input
          type="checkbox"
          :id="`level-filter-${level.level}`"
          v-model="level.selected"
          @change="applyFilter"
        >

        <label :for="`level-filter-${level.level}`">
          {{ level.level }}
        </label>
      </div>
    </div>

    <div class="filter-type">
      <div v-for="tagFilter in tagFilters" class='inline-filter tag-block'>
        <input
          type="checkbox"
          :id="`tag-filter-${tagFilter.property}`"
          v-model="tagFilter.selected"
          @change="applyFilter"
        >

        <label :for="`tag-filter-${tagFilter.property}`">
          {{ tagFilter.property }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce, sortBy, compact, flatten, map, values, isEmpty, every } from 'lodash';

  export default {
    name: 'list-filter',

    props: {
      list: {
        type:     Array,
        required: true
      },

      tags: {
        type:    Array
      },

      onFilter: {
        type: Function,
        required: true
      },

      filterLevels: {
        type: Boolean,
        default: false
      }
    },

    data: function() {
      return {
        filter: '',
        tagFilters: this.tags.map(function(tag){
          return {
            property: tag,
            selected: false
          }
        }),
        levelFilters: this.list.reduce((coll, item) => {
          const level = item.get('level');

          if (coll.find(item => item.level == level)) return coll;

          coll.push({
            level: level,
            selected: false
          })

          return sortBy(coll, item => item.level)
        }, [])
      }
    },

    methods: {
      applyFilter: debounce(function(){
        this.onFilter(this.filteredList);
      }, 150),

      checkFilterValidity: function(value) {
        return value.toLowerCase().includes(this.filter.toLowerCase());
      },

      extractStringValues: function(value){
        if (!value) { return []; }

        if (typeof(value) == 'string') { return [value]; }

        if (typeof(value) == 'object') {
          return flatten(map(values(value), (nested) => this.extractStringValues(nested)));
        }

        return [];
      },

      checkSearchValidity: function(item) {
        const searchableText = compact(this.extractStringValues(item.attributes)).join(' ');

        return this.checkFilterValidity(searchableText);
      },

      checkLevelValidity(item) {
        return this.selectedLevels.includes(item.get('level'));
      },

      createTagFilterFunc: function(filter) {
        return function(item) {
          return item.tagNames().includes(filter.property);
        };
      },

      itemIsValid: function(item) {
        return every(this.applicableFilters, function(filter){
          return filter(item);
        });
      }
    },

    computed: {
      filteredList: function() {
        return this.list.filter(this.itemIsValid);
      },

      selectedTagFilters: function() {
        return this.tagFilters.filter((filter) => filter.selected)
      },

      selectedLevels() {
        return this.levelFilters.filter(level => level.selected).map(level => level.level);
      },

      applicableFilters: function () {
        const applicableFilters = this.selectedTagFilters.map(this.createTagFilterFunc)

        if (!isEmpty(this.filter)) {
          applicableFilters.push(this.checkSearchValidity)
        }

        if (this.filterLevels && !isEmpty(this.selectedLevels)) {
          applicableFilters.push(this.checkLevelValidity)
        }

        return applicableFilters;
      }
    }
  }
</script>
